import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useAndReportExperimentTreatment } from '../experiments';
import { useCurrentSessionUser } from '../session';

type UseShowStorylineAdminSettings = () => boolean;
export const useShowStorylineAdminSettings: UseShowStorylineAdminSettings = () => {
  const isStorylineAdminEnabled = useAndReportExperimentTreatment(Experiment.StorylineAdmin) === 'enabled';
  const { isNetworkAdmin } = useCurrentSessionUser();

  return isStorylineAdminEnabled && isNetworkAdmin;
};
